module.exports = __webpack_public_path__ + "img/work_complete.eb846d0a.png";